// 設備信息收集服務
export interface DeviceInfo {
  platform: string;
  browser: string;
  deviceType: string;
  screenResolution: string;
  timezone: string;
  userAgent: string;
}

export class DeviceInfoService {
  private static instance: DeviceInfoService;
  private deviceInfo: DeviceInfo | null = null;

  private constructor() {}

  public static getInstance(): DeviceInfoService {
    if (!DeviceInfoService.instance) {
      DeviceInfoService.instance = new DeviceInfoService();
    }
    return DeviceInfoService.instance;
  }

  public collectDeviceInfo(): DeviceInfo {
    if (this.deviceInfo) {
      return this.deviceInfo;
    }

    const userAgent = navigator.userAgent;
    
    // 檢測平台
    const platform = this.detectPlatform(userAgent);
    
    // 檢測瀏覽器
    const browser = this.detectBrowser(userAgent);
    
    // 檢測設備類型
    const deviceType = this.detectDeviceType(userAgent);
    
    // 獲取螢幕解析度
    const screenResolution = this.getScreenResolution();
    
    // 獲取時區
    const timezone = this.getTimezone();

    this.deviceInfo = {
      platform,
      browser,
      deviceType,
      screenResolution,
      timezone,
      userAgent
    };

    return this.deviceInfo;
  }

  private detectPlatform(userAgent: string): string {
    if (userAgent.includes('Windows')) return 'Windows';
    if (userAgent.includes('Mac OS')) return 'macOS';
    if (userAgent.includes('Linux')) return 'Linux';
    if (userAgent.includes('Android')) return 'Android';
    if (userAgent.includes('iOS')) return 'iOS';
    return 'Unknown';
  }

  private detectBrowser(userAgent: string): string {
    if (userAgent.includes('Chrome')) return 'Chrome';
    if (userAgent.includes('Firefox')) return 'Firefox';
    if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) return 'Safari';
    if (userAgent.includes('Edge')) return 'Edge';
    if (userAgent.includes('Opera')) return 'Opera';
    return 'Unknown';
  }

  private detectDeviceType(userAgent: string): string {
    if (userAgent.includes('Mobile') || userAgent.includes('Android') || userAgent.includes('iPhone')) {
      return 'Mobile';
    }
    if (userAgent.includes('Tablet') || userAgent.includes('iPad')) {
      return 'Tablet';
    }
    return 'Desktop';
  }

  private getScreenResolution(): string {
    return `${screen.width}x${screen.height}`;
  }

  private getTimezone(): string {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
      return 'Unknown';
    }
  }

  public getDeviceInfo(): DeviceInfo | null {
    return this.deviceInfo;
  }
}

export default DeviceInfoService;

